export const productColors: Record<string, string> = {
    PPC: "#008695", // Paid Search
    FDA: "#e68310", // Paid Social
    SM: "#e68310", // Paid Social
    DSP: "#e73f74", // Display
    YOU: "#f2b701", // Video
};

// Qualitative color palette *Bold* from https://carto.com/carto-colors/
export const campaignColorsDef = [
    "#7f3c8d",
    "#11a579",
    "#3969ac",
    "#f2b701",
    "#e73f74",
    "#80ba5a",
    "#e68310",
    "#008695",
    "#cf1c90",
    "#f97b72",
    "#4b4b8f",
    "#a5aa99",
];

export const productIds: Record<string, number> = {
    PPC: 1,
    FDA: 14,
    SM: 14,
    DSP: 3,
    YOU: 15,
};

export const locationProducts = [
    {
        id: 1,
        name: "Paid Search",
        value: "PPC",
        color: "bg-products-PPC",
        icon: "/table-map/product-icons-product-paid-search-22.svg",
    },
    {
        id: 14,
        name: "Paid Social",
        value: "FDA",
        color: "bg-products-FDA",
        icon: "/table-map/product-icons-product-paid-social-22.svg",
    },
    {
        id: 3,
        name: "Display",
        value: "DSP",
        color: "bg-products-DSP",
        icon: "/table-map/product-icons-product-display-22.svg",
    },
    {
        id: 15,
        name: "Video",
        value: "YOU",
        color: "bg-products-YOU",
        icon: "/table-map/product-icons-product-video-22.svg",
    },
];
